import adapter from 'garaje/utils/decorators/adapter';

import SignInFieldModel from './sign-in-field';

@adapter('invite-sign-in-field')
class InviteSignInField extends SignInFieldModel {
  // Inherits all properties and relationships from SignInFieldModel
}

export default InviteSignInField;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'invite-sign-in-field': InviteSignInField;
  }
}
